module.exports = __webpack_public_path__ + "img/star_hollow.7ad23c07.png";